import { render, staticRenderFns } from "./examCheckboxSelect.vue?vue&type=template&id=3b1c3600&scoped=true&name=examCheckboxSelect&"
import script from "./examCheckboxSelect.vue?vue&type=script&lang=js&"
export * from "./examCheckboxSelect.vue?vue&type=script&lang=js&"
import style0 from "./examCheckboxSelect.vue?vue&type=style&index=0&id=3b1c3600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c3600",
  null
  
)

export default component.exports